import { render, staticRenderFns } from "./Ringtone.vue?vue&type=template&id=36eea86d&"
import script from "./Ringtone.vue?vue&type=script&lang=js&"
export * from "./Ringtone.vue?vue&type=script&lang=js&"
import style0 from "./Ringtone.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports